module.exports = __webpack_public_path__ + "static/media/blog-hai-doors@3x.69fb74fd.jpg";